import { FunctionComponent, useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { handlingUrlParams } from "../../Utils/AppUtils";
import AdminServices from "services/admin-services";
// import { Button } from "primereact/button";
// import { Sidebar } from "primereact/sidebar";
import moment from "moment";
import { Checkbox } from "primereact/checkbox";
// import AddInvestor from "../investor/AddInvestor";

interface InvestorsProps {}

const Investors: FunctionComponent<InvestorsProps> = () => {
  // const [showPackageModel, setShowPackageModel] = useState<boolean>(false);
  const [customerData, setCustomerData] = useState([] as any);
  const [loading, setLoading] = useState<boolean>(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 10,
    page: 1,
    sortField: null,
    sortOrder: null,
  });

  useEffect(() => {
    loadLazyData();
  }, [lazyParams]);

  const loadLazyData = () => {
    setLoading(true);
    AdminServices.getInvestors(
      handlingUrlParams({
        PageNumber: lazyParams.page,
        PageSize: lazyParams.rows,
        // eslint-disable-next-line prettier/prettier
      }),
    )
      .then((response: any) => {
        const getHeaders = response.headers;
        const parsedHeaders = JSON.parse(getHeaders["x-pagination"]);
        setCustomerData(response.data);
        setTotalRecords(parsedHeaders.TotalCount);
        setLoading(false);
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };

  const onPage = (event: any) => {
    setLazyParams({
      ...lazyParams,
      first: event.first, // index of first record in current page
      rows: event.rows, // rows per page
      page: event.page + 1, // 1-based page for backend
    });
  };

  const onSort = (event: any) => {
    setLazyParams(event);
  };

  const renderFilters = () => {
    return (
      <div className="flex flex-row justify-between items-center">
        <h2 className="text-xl font-bold">List of Investors</h2>
        {/* <Button
          onClick={showOverpanel}
          label="Add Investor"
          className="p-button-sm p-button-outlined p-button-success"
        /> */}
      </div>
    );
  };

  // const showOverpanel = () => {
  //   setShowPackageModel(true);
  // };

  const pullCriteria = (rowData: any) => {
    if (!rowData?.pullCriteria) return <>NA</>;

    let parsedData;
    try {
      parsedData = JSON.parse(rowData.pullCriteria);
    } catch (err) {
      return <>Invalid JSON</>;
    }

    const fields = parsedData?.fields || [];
    const filters = parsedData?.filter?.terms || [];

    return (
      <div className="text-sm">
        {/* Fields */}
        {fields.length > 0 && (
          <div className="mb-2">
            <strong>Fields:</strong>
            <ul className="list-disc list-inside">
              {fields.map((field: string, idx: number) => (
                <li key={idx}>{field}</li>
              ))}
            </ul>
          </div>
        )}

        {/* Filters */}
        {filters.length > 0 && (
          <div>
            <strong>Filters:</strong>
            <ul className="list-disc list-inside">
              {filters.map((term: any, idx: number) => (
                <li key={idx}>
                  <span className="font-medium">{term.canonicalName}</span>:{" "}
                  {Array.isArray(term.value)
                    ? term.value.join(", ")
                    : term.value}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  };

  const renderStartDate = (rowData: any) => {
    return (
      <>
        <span className=" text-ellipsis overflow-hidden">
          {moment(rowData.startDate).format("MM/DD/YYYY HH:mm a")}
        </span>
      </>
    );
  };

  const renderEndDate = (rowData: any) => {
    const date = rowData?.endDate;

    if (!date || !moment(date).isValid()) {
      return <span>NA</span>;
    }

    return (
      <span className="text-ellipsis overflow-hidden">
        {moment(date).format("MM/DD/YYYY hh:mm A")}
      </span>
    );
  };

  const enableClassificationCheck = (rowData: any) => {
    return (
      <>
        <Checkbox disabled checked={rowData?.enableClassification} />
      </>
    );
  };

  return (
    <>
      <DataTable
        className="shadow-md"
        scrollable
        scrollHeight="400px"
        value={customerData}
        loading={loading}
        stripedRows
        lazy={true}
        paginator={true}
        filterDisplay="menu"
        responsiveLayout="scroll"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        dataKey="id"
        rowsPerPageOptions={[10, 20, 50]}
        emptyMessage="No Billing Codes found."
        totalRecords={totalRecords}
        rows={lazyParams.rows}
        first={lazyParams.first}
        onPage={onPage}
        onSort={onSort}
        sortOrder={lazyParams.sortOrder}
        header={renderFilters}
      >
        <Column field="name" header="Name"></Column>
        <Column field="description" header="Description"></Column>
        <Column body={pullCriteria} header="Pull Criteria"></Column>
        <Column body={renderStartDate} header="Start Date"></Column>
        <Column body={renderEndDate} header="End Date"></Column>
        <Column
          body={enableClassificationCheck}
          header="Enable Classification"
        ></Column>
      </DataTable>
    </>
  );
};

export default Investors;
